import React, { useState } from "react";
import styles from "./AccordionSection.module.css";

function AccordionItem({ title, emoji, role, description, links }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.item}>
      <button className={styles.itemBtn} onClick={() => setOpen(!open)}>
        <div className={styles.itemLeft}>
          {emoji && (
            <span className={`${styles.emoji} ${open ? styles.emojiActive : ""}`}>
              {emoji}
            </span>
          )}
          <span className={styles.itemTitle}>{title}</span>
          <span className={styles.itemRole}>{role}</span>
        </div>
        <span className={`${styles.toggle} ${open ? styles.toggleOpen : ""}`}>
          +
        </span>
      </button>
      {open && (
        <div className={styles.body}>
          <p className={styles.desc}>{description}</p>
          {links && (
            <div className={styles.links}>
              {links.map((link, i) => (
                <a
                  key={i}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  {link.label} ↗
                </a>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function AccordionSection({ title, items, delay }) {
  return (
    <section
      className={styles.section}
      style={{ opacity: 0, animation: `fadeIn 0.6s ease-out ${delay || "0.2s"} forwards` }}
    >
      <h2 className={styles.heading}>{title}</h2>
      <div className={styles.list}>
        {items.map((item, i) => (
          <AccordionItem key={i} {...item} />
        ))}
      </div>
    </section>
  );
}

export { AccordionSection, AccordionItem };
export default AccordionSection;
